/* eslint-disable react/react-in-jsx-scope */
import { useEffect } from "react";
import Store from "@/store";
import { UserStore } from "@/store/user";
import { Button, Card, Container, Typography } from "@mui/material";
import { inject, observer } from "mobx-react";
import { enqueueSnackbar } from "notistack";
import { useState } from "react";
import OtpInput from "react-otp-input";
import { useNavigate } from "react-router-dom";
import { autorun } from "mobx";
import theme from "@/MUITheme";
interface UI_STATE {
  state: "checking" | "sending" | "verifying" | "verified" | "error";
}

const PhoneNumberVerifyPage = inject(Store.type.userStore)(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  observer((props: any) => {
    const userStore = props[Store.type.userStore] as UserStore;
    const [uiState, setUIState] = useState<UI_STATE>({
      state: "checking",
    });
    const navigate = useNavigate();
    const [otp, setOtp] = useState("");

    useEffect(() => {
      const disposeAutorun = autorun(() => {
        if (userStore.isPhoneVerified === true) {
          setUIState({ state: "verified" });
        }
      });

      return () => disposeAutorun();
    }, [userStore]);

    const requestVerifyPhoneNumber = async () => {
      setUIState({ state: "sending" });
      try {
        await userStore.requestVerifyPhoneNumber();
        setUIState({ state: "verifying" });
      } catch (error) {
        console.error(error);
        setUIState({ state: "checking" });
        enqueueSnackbar("Error requesting phone number verification", {
          variant: "error",
        });
      }
    };
    const verifyPhoneNumber = async () => {
      setUIState({ state: "verifying" });
      try {
        await userStore.verifyPhoneNumber(otp);
        await userStore.fetchProfile();
        setUIState({ state: "verified" });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (error: any) {
        if (error.raw.message === "invalid OTP code") {
          enqueueSnackbar("Failed to veriy phone number: invalid OTP code", {
            variant: "error",
          });
        } else {
          enqueueSnackbar("Failed to veriy phone number: " + error.message, {
            variant: "error",
          });
        }
      }
    };
    return (
      <Container
        maxWidth="lg"
        sx={{
          py: "82px",
          [theme.breakpoints.up("lg")]: { maxWidth: "lg", py: "82px" },
        }}
      >
        <Card
          sx={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            gap: "40px",
            padding: "16px",

            minHeight: "428px",
          }}
        >
          <Typography variant="h2">Verify your phone number</Typography>
          {uiState.state === "checking" && (
            <>
              <Typography variant="h4">
                {userStore.profile?.phone_number}
              </Typography>
              <Button
                size="large"
                variant="contained"
                onClick={() => requestVerifyPhoneNumber()}
              >
                Get code
              </Button>
            </>
          )}
          {uiState.state === "sending" && (
            <Typography variant="body1">
              Sending verification code...
            </Typography>
          )}
          {uiState.state === "verifying" && (
            <>
              <OtpInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                inputStyle={{
                  zIndex: 9999,
                  width: "60px",
                  height: "60px",
                  fontSize: "24px",
                  borderRadius: "20px",
                  margin: "0 10px",
                  borderStyle: "solid",
                  borderColor: theme.palette.primary.main,
                }}
                renderSeparator={<span> </span>}
                renderInput={(props) => <input {...props} />}
              />
              <Button
                variant="contained"
                size="large"
                disabled={otp.length < 6}
                onClick={() => verifyPhoneNumber()}
              >
                Verify
              </Button>
            </>
          )}
          {uiState.state === "verified" && (
            <>
              <Typography variant="h2">Verified!</Typography>
              <Button
                variant="contained"
                size="large"
                onClick={() => navigate("/profile")}
              >
                Back to profile
              </Button>
            </>
          )}
        </Card>
      </Container>
    );
  }),
);
export default PhoneNumberVerifyPage;
